import React from 'react'
import { SpecsWrapper } from '../styles'
import messages from '../messages'
import { Col } from 'react-bootstrap'
import ReactPlayer from 'react-player'

const SpecContent = ({
  device,
  language,
  getOption,
  openModal,
  createUserEvent,
  renderList,
  RenderFeatures,
  RenderSpecs,
  version
}) => {
  const translated = messages[language]

  if (Object.keys(device).length === 0) {
    return <div>Loading...</div>
  }

  return (
    <SpecsWrapper version={version} className="specs-content">
      <Col
        className="small-column"
        sm={12}
        md={
          device.features.length ||
          device.featurevaluepairs.length ||
          device.featureVideo.url
            ? 3
            : 12
        }
      >
        <h1>{device.phone.name_pretty}</h1>
        <img alt={`${device.phone.name_pretty}`} src={device.image.url} />
        {!getOption('specs.disableManuals') &&
          device.manual &&
          device.manual.url && (
            <button
              type="button"
              onClick={() => {
                openModal('ShowUserManual')
              }}
            >
              {getOption('specs.manualTitle', translated.manual)}
            </button>
          )}
        {!getOption('specs.disableManuals') &&
          device.booklet &&
          device.booklet.url && (
            <button
              type="button"
              onClick={() => {
                openModal('ShowBooklet')
              }}
            >
              {getOption('specs.bookletTitle', translated.booklet)}
            </button>
          )}
      </Col>
      <Col
        sm={12}
        md={
          device.features.length ||
          device.featurevaluepairs.length ||
          device.featureVideo.url
            ? 9
            : 0
        }
        style={{ marginTop: '5px' }}
      >
        <div className={device.featureVideo.url ? 'embed-container' : ''}>
          <If condition={device.featureVideo.url}>
            <ReactPlayer
              url={device.featureVideo.url}
              key={device.featureVideo.url}
              controls
              width="100%"
              height="100%"
              onStart={() =>
                createUserEvent({
                  category: 'specs',
                  data: { action: 'PlayFeatureVideo' }
                })
              }
            />
          </If>
        </div>
        {renderList(
          RenderFeatures(device.features),
          translated['feature'],
          'Features',
          !Boolean(device.featureVideo.url)
        )}
        {renderList(
          RenderSpecs(device.featurevaluepairs),
          translated['spec'],
          'Specs',
          !Boolean(device.featureVideo.url)
        )}
      </Col>
    </SpecsWrapper>
  )
}

export default SpecContent



// WEBPACK FOOTER //
// ./src/components/Specs/components/SpecContent.js